// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2,
        showPlaceholderProductList: true
    }
};


// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add a specific class for grid item
    var gridItemWidthClass = '';
    var imageSize = '600x600';
    var width = '', height = '';
    switch(bcSfFilterConfig.custom.products_per_row) {
        case 2:
            gridItemWidthClass = 'medium--one-half large--one-half';
            imageSize = '540x600';
            width = 540;
            height = 600;
            break;
        case 3:
            gridItemWidthClass = 'small--one-half medium--one-third large--one-third';
            imageSize = '345x550';
            width = 345;
            height = 550;
            break;
        case 4:
            gridItemWidthClass = 'small--one-half medium--one-quarter large--one-quarter';
            imageSize = '250x';
            width = 250;
            height = 225;
            break;
        case 5:
            gridItemWidthClass = 'small--one-half medium--one-fifth large--one-fifth';
            imageSize = '195x';
            width = 195;
            height = 125;
            break;
    }
    itemHtml = itemHtml.replace(/{{gridItemWidthClass}}/g, gridItemWidthClass);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
    itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

    // Add soldOut label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], imageSize) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '<span class="h1 medium--left">';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price  + '</span>';
    } else {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
    }
    itemPriceHtml += buildPriceHtml(data.price_min);
    if (onSale && bcSfFilterConfig.custom.show_compare_at_price) {
        itemPriceHtml += ' <small><s><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
        itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
        itemPriceHtml += '</s></small>';
    }
    itemPriceHtml += '</span>';
    if (onSale && bcSfFilterConfig.custom.product_show_saved_amount) {
        var class1 = bcSfFilterConfig.custom.show_compare_at_price ? ' medium--right ' : '';
        var class2 = bcSfFilterConfig.custom.product_reviews_enable ? ' has-reviews' : '';
        var savePrice = data.compare_at_price_min - data.price_min;
        savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
        itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
        itemPriceHtml += bcSfFilterConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    //Add review
    var itemReviewHtml = bcSfFilterConfig.custom.product_reviews_enable ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span><br>' : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    //Add image
    var aspect_ratio = null;
    var itemImgHtml = '';
    if (images.length > 0) {
        aspect_ratio = images[0]['width'] / images[0]['height'];
        var max_width = width;
        var max_height = height;
        if (aspect_ratio < 1) {
            max_width = height * aspect_ratio;
            if (images[0]['height'] < height) {
                max_height = images[0]['height'];
                max_width = images[0]['width'];
            } else {
                max_height = height;
            }
        } else {
            max_height = width / aspect_ratio;
            if (images[0]['width'] < width) {
                max_height = images[0]['height'];
                max_width = images[0]['width'];
            } else {
                max_width = width;
            }
        }
        itemImgHtml +=  '<div class="lazyload__image-wrapper no-js" style="max-width:' + max_width + 'px">' +
                            '<div style="padding-top:' + 1 / aspect_ratio * 100 + '%;">' +
                                '<img class="lazyload no-js" data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' +
                                    'data-widths="[125, 180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspect_ratio +'" ' +
                                    'data-sizes="auto" alt="{{itemTitle}}"' +
                                '/>' +
                            '</div>' +
                        '</div>' +
                        '<noscript>' +
                            '<img src="' + this.getFeaturedImage(images, '580x') + '"' +
                                'srcset="' + this.getFeaturedImage(images, '580x') + ' 1x, ' + this.getFeaturedImage(images, '580@2x') + ' 2x" ' +
                                'alt="{{itemTitle}}" style="opacity:1;"' +
                            '/>' +
                        '</noscript>';
    } else {
        itemImgHtml +=  '<div>' +
                            '<img src="' + bcSfFilterConfig.general.no_image_url + '"/>' +
                        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

    // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

BCSfFilter.prototype.buildProductListItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
    itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

    // Add soldOut label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '<span class="h1 medium--left">';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price  + '</span>';
    } else {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
    }
    itemPriceHtml += buildPriceHtml(data.price_min);
    if (onSale && bcSfFilterConfig.custom.show_compare_at_price) {
        itemPriceHtml += ' <small><s><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
        itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
        itemPriceHtml += '</s></small>';
    }
    itemPriceHtml += '</span>';
    if (onSale && bcSfFilterConfig.custom.product_show_saved_amount) {
        var class1 = bcSfFilterConfig.custom.show_compare_at_price ? ' medium--right ' : '';
        var class2 = bcSfFilterConfig.custom.product_reviews_enable ? ' has-reviews' : '';
        var savePrice = data.compare_at_price_min - data.price_min;
        savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
        itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
        itemPriceHtml += bcSfFilterConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

function buildPriceHtml(price) {
    var customPrice = bcsffilter.formatMoney(price);
    if (!(bcsffilter.moneyFormat.indexOf('money') > -1 || bcsffilter.moneyFormat.indexOf('.') > -1)) {
        if (bcSfFilterConfig.custom.superscript_decimals) {
            if (bcsffilter.moneyFormat.indexOf('{{amount}}') !== -1 || bcsffilter.moneyFormat.indexOf('{{ amount }}') !== -1) {
                customPrice = customPrice.replace('.', '<sup>') + '</sup>';
            } else if (bcsffilter.moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1 || bcsffilter.moneyFormat.indexOf('{{ amount_with_comma_separator }}') !== -1) {
                customPrice = customPrice.replace(',', '<sup>') + '</sup>';
            }
        }
    }
    var html = '<small aria-hidden="true">' + customPrice + '</small>';
    html += '<span class="visually-hidden">' + bcsffilter.formatMoney(price) + '</span>';
    return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    if (jQ(this.selector.topDisplayType).length > 0) {
        var itemHtml = bcSfFilterTemplate.displayTypeHtml;
        itemHtml = itemHtml.replace(/{{gridUrl}}/g, this.buildToolbarLink('display', 'list', 'grid'));
        itemHtml = itemHtml.replace(/{{listUrl}}/g, this.buildToolbarLink('display', 'grid', 'list'));
        jQ(this.selector.topDisplayType).html(itemHtml);

        // Active current display type
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('collection-view--active');
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('collection-view--active');
        if (this.queryParams.display == 'list') {
            jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('collection-view--active');
        } else if (this.queryParams.display == 'grid') {
            jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('collection-view--active');
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
        var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml;
        var colInfo = colData.collection;
        var currentCollectionHtml = '';
        if (Array.isArray(bcSfFilterConfig.general.current_tags) && bcSfFilterConfig.general.current_tags.length > 0) {
            currentCollectionHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
            currentCollectionHtml += ' <span class="divider" aria-hidden="true">&rsaquo;</span>'
            currentCollectionHtml += ' <span>' + current_tags.join(' + ') + '</span>';
        } else {
            currentCollectionHtml += ' <span>' + colInfo.title + '</span>';
        }
        breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollection}}/g, currentCollectionHtml);
        jQ('.breadcrumb').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }
    /* end-initialize-bc-al */};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    jQ(document).ready(function() {
        if (typeof theme !== 'undefined' && theme.hasOwnProperty('Sections')) {
            var sections = new theme.Sections();
            sections.register('collection-template', theme.Collection);
        }
    });

    if (window.SPR) {
        SPR.initDomEls();
        SPR.loadBadges();
    }
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
